import { OnRaceBetsSchema } from './OnRaceBets.styles';

export const onRaceBetStyles: OnRaceBetsSchema = {
  wrapper: {
    mb: '2',
    bg: 'white',
    border: '1px',
    borderRadius: 'lg',
    borderColor: 'alpha.200',
    flexDirection: 'column',
    p: '2',
  },
  headerWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: 'gray.700',
  },
  headerCountText: {
    ml: '1',
    fontSize: 'sm',
    fontWeight: 'semibold',
    color: 'gray.700',
  },
  headerExpandButton: {
    variant: 'primary',
    ml: 'auto',
    mr: '1',
    boxSize: '7',
  },
  toggleIcon: {
    boxSize: '4',
  },
  betsContainer: {
    flexDirection: 'column',
  },
  betCategoryWrapper: {
    alignItems: 'center',
    mt: '2',
  },
  betCategory: {
    fontSize: 'sm',
    fontWeight: 'semibold',
    color: 'gray.700',
  },
  betCategoryCount: {
    fontSize: 'xs',
    fontWeight: 'semibold',
    color: 'gray.700',
    ml: '1',
  },
  divider: {
    borderWidth: 'px',
    opacity: '1',
    borderColor: 'gray.700Alpha.400',
    mt: '1.5',
  },
  betRow: {
    py: '2',
  },
  betRowDivider: {
    borderBottomWidth: '1px',
    borderBottomColor: 'gray.700Alpha.200',
    borderBottomStyle: 'dashed',
  },
  groupDivider: {
    borderBottomWidth: '1px',
    borderBottomColor: 'gray.700Alpha.400',
  },
  categoryIcon: {
    color: 'gray.700',
    boxSize: '6',
  },
  groupContainer: {
    flexDir: 'column',
    py: 2,
    borderBottomColor: 'gray.700Alpha.400',
  },
  groupTitleText: {
    color: 'gray.700',
    fontSize: 'sm',
    fontWeight: 'bold',
  },
  runnerText: {
    color: 'gray.700',
    fontSize: 'sm',
    fontWeight: 'extrabold',
    textTransform: 'capitalize',
  },
  runnerBarrierText: {
    color: 'gray.500',
    fontSize: 'xs',
  },
  stakeText: {
    color: 'gray.700',
    fontSize: 'xs',
    fontWeight: 'gray.700',
  },
  potentialWinningsText: {
    color: 'gray.700',
    fontSize: 'xs',
    fontWeight: 'gray.700',
  },
  subtitleText: {
    color: 'gray.700',
    fontSize: 'xs',
    fontWeight: 'medium',
  },
  exoticsPositionText: {
    color: 'gray.700',
    fontSize: 'xs',
    fontWeight: 'bold',
    w: 9,
  },
  viewMoreButton: {
    alignItems: 'center',
    justifyContent: 'center',
    mx: -2,
    mb: -2,
    borderTopRadius: 0,
    height: 8,
  },
  viewMoreButtonText: {
    fontWeight: 'gray.700',
    fontSize: 'sm',
    textTransform: 'uppercase',
  },
  srmBlendedLegContainer: {
    flexDir: 'row',
    flex: '1',
  },
  srmBlendedRunnerText: {
    width: 32,
    fontWeight: 'bold',
    color: 'gray.700',
    fontSize: 'xs',
    textTransform: 'capitalize',
  },
  srmMarketText: {
    fontWeight: 'bold',
    color: 'gray.700',
    fontSize: 'xs',
  },
  srmBlendedWrapper: {
    flexDir: 'column',
    flex: 1,
  },
  flexiText: {
    fontWeight: 'bold',
    color: 'gray.700',
    fontSize: 'xs',
  },
  flexiStakeText: {
    width: '16',
    color: 'gray.700',
  },
  flexiStakeValueText: {
    color: 'alpha.400',
    fontWeight: 'bold',
  },
};
